// שגיאת רינדור (11 §4): במקום מסך לבן — הודעה בעברית וכפתור "רענן". resetKey (ב-Layout: הנתיב) מנקה את השגיאה
// כשעוברים למסך אחר — בלי key על הרכיב, כדי שמעבר נתיב רגיל (/ai2 → /ai2/<id>) לא ימחק את ה-state של המסך (טיוטה, קבצים).
// השגיאה נרשמת ל-console (לא נשלחת לשרת). קומפוננטת class — React 18 לא נותן גבול שגיאה כ-hook.
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { T } from '../lib/strings.ts';
import { Button } from './ui/button.tsx';
import { IconAlert, IconRefresh } from './brand/icons.tsx';

type State = { error: unknown };

export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, State> {
  override state: State = { error: null };

  override componentDidUpdate(prev: { resetKey?: string }) {
    if (this.state.error != null && prev.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  static getDerivedStateFromError(error: unknown): State {
    return { error };
  }

  override componentDidCatch(error: unknown, info: ErrorInfo) {
    console.error('render error', error, info.componentStack);
  }

  override render() {
    if (this.state.error == null) return this.props.children;
    const msg = this.state.error instanceof Error ? this.state.error.message : String(this.state.error);
    return (
      <div role="alert" data-testid="render-error" className="flex items-start gap-3 rounded-md border border-error/35 bg-error/[0.06] p-4">
        <span className="grid size-9 shrink-0 place-items-center rounded-circle bg-error/12 text-error">
          <IconAlert size={18} />
        </span>
        <div className="flex min-w-0 flex-col gap-2 pt-1.5">
          <p className="m-0 font-semibold">{T.renderError}</p>
          <p className="m-0 truncate text-xs text-muted-foreground" dir="ltr" data-testid="render-error-detail">
            {msg}
          </p>
          <Button variant="outline" size="sm" className="w-fit" onClick={() => window.location.reload()}>
            <IconRefresh size={16} />
            {T.refresh}
          </Button>
        </div>
      </div>
    );
  }
}
